<template>
  <div class="modal fade" id="manageUnitModal">
    <Loader v-if="loading" />
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div style="width: 100%">
            <div class="row">
              <div class="col-auto pr-0">
                <i
                  class="material-icons pointer pt-2 pr-2"
                  role="button"
                  v-on:click="page = -1"
                  v-bind:id="'archiveUnit'"
                  @mouseover="$showTooltip('#archiveUnit')"
                  @mouseleave="$hideTooltip('#archiveUnit')"
                  data-placement="top"
                  title="Archive this Unit and all student data associated with it."
                  >archive</i
                >
              </div>
              <div class="col pl-0">
                <input
                  class="form-control form-control-lg"
                  type="text"
                  v-model="unitTitle"
                />
              </div>
            </div>
            <input
              class="form-control form-control-sm mt-1"
              type="text"
              v-model="unitDescription"
              placeholder="Description"
            />
          </div>
          <div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <button
              type="button"
              class="btn btn-primary mt-4"
              v-on:click="updateUnit"
            >
              Update Unit
            </button>
          </div>
        </div>
        <div v-if="Unit != null" class="modal-body">
          <div v-if="page == -1">
            <h5>
              Are you sure you want to archive this unit and all of the related
              data?
            </h5>
            <div class="row">
              <div class="col text-left">
                <button
                  type="button"
                  v-on:click="page = 1"
                  class="btn btn-secondary"
                >
                  Cancel
                </button>
              </div>
              <div class="col-auto">
                <button
                  type="button"
                  v-on:click="archiveUnit"
                  class="btn btn-primary"
                >
                  Archive Unit
                </button>
              </div>
            </div>
          </div>

          <div v-if="page == 1">
            <div
              class="row container text-left pt-0"
              v-if="scoreTemplate != null"
            >
              <div class="col">
                <div v-if="!changingTemplate" class="row">
                  <div class="col-auto">
                    <h6 class="pt-1 mb-0">
                      <b>Score Template: {{ scoreTemplate.Title }}</b>
                    </h6>
                  </div>
                  <div class="col-auto" id="changeTemplate">
                    <button
                      class="btn btn-sm btn-link pb-0"
                      v-if="Unit.Num_Scores == 0"
                      v-on:click="changeTemplate"
                    >
                      Change Template
                    </button>
                  </div>
                </div>
                <div v-else>
                  <label for="editScoreTemplate">Unit Score Template</label>
                  <div class="row">
                    <div class="col-auto">
                      <select
                        id="editScoreTemplate"
                        class="selectpicker d-block"
                        data-style="btn-outline-primary"
                        data-none-selected-text="Select Score Template"
                        data-actions-box="true"
                        data-selected-text-format="count"
                        v-model="selectedScoreTemplate"
                      >
                        <option
                          v-for="template in ScoreTemplates"
                          :key="template.Score_Template_Id"
                          v-bind:value="template"
                        >
                          {{ template.Title }}
                        </option>
                      </select>
                    </div>
                    <div class="col-auto">
                      <button
                        class="btn btn-secondary"
                        v-on:click="cancelEditTemplate"
                      >
                        Cancel
                      </button>
                    </div>
                    <div class="col-auto">
                      <button class="btn btn-primary" v-on:click="updateUnit">
                        Save
                      </button>
                    </div>
                  </div>
                </div>
                <p class="text-secondary">
                  <small
                    >** You can change the score template if no data has been
                    taken in this unit.</small
                  >
                </p>
                <div
                  class="ml-3"
                  v-for="input in selectedScoreTemplate.Score_Template_Inputs.slice().sort(
                    $orderByOrder
                  )"
                  :key="input.Score_Template_Input_Id"
                >
                  <label class="mb-0"
                    >{{ input.Order }}) {{ input.Request }}</label
                  >
                  <label class="ml-2"
                    ><small
                      >({{ $getScoreTemplateInputSummary(input) }})</small
                    ></label
                  >
                </div>
              </div>
            </div>
            <div class="text-left container mt-3">
              <h6><b>Students:</b></h6>
            </div>
            <div v-if="getUnitStudents().length == 0">
              There are no students assigned to this unit.
            </div>
            <div
              class="row container ml-2"
              v-for="student in getUnitStudents()
                .slice()
                .sort($orderByName)"
              :key="'student' + student.Student_Id"
            >
              <div class="col">
                <div class="row">
                  <div class="col-auto px-0">
                    <i
                      class="material-icons pointer"
                      v-bind:id="
                        'studentToggleIcon' +
                          student.Student_Id +
                          'unit' +
                          Unit.Unit_Id
                      "
                      data-toggle="collapse"
                      v-bind:href="
                        '#studentDetails' +
                          student.Student_Id +
                          'unit' +
                          Unit.Unit_Id
                      "
                      role="button"
                      aria-expanded="false"
                      v-on:click="selectStudent(student.Student_Id)"
                      >add</i
                    >
                  </div>
                  <div class="col-auto">
                    <p class="mb-0">{{ student.Name }}</p>
                  </div>
                </div>
                <div
                  class="row container py-0 collapse"
                  v-bind:id="
                    'studentDetails' +
                      student.Student_Id +
                      'unit' +
                      Unit.Unit_Id
                  "
                >
                  <div class="col">
                    <div class="row">
                      <div
                        class="mb-1 col"
                        style="background-color:gray; height:1px; width:100%"
                      />
                    </div>
                    <div class="row">
                      <div class="col">
                        <StudentUnitScores
                          v-if="scoreTemplate != null"
                          v-bind:Student="student"
                          v-bind:ScoreTemplate="scoreTemplate"
                          v-bind:Scores="
                            getStudentUnitScores(student.Student_Id)
                          "
                          v-bind:Unit="Unit"
                          v-bind:HideStudentName="true"
                          @archive-unit="archiveStudentUnit"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import StudentUnitScores from "@/components/Score/StudentUnitScores.vue";
import Loader from "@/components/Loader.vue";

export default {
  components: {
    StudentUnitScores,
    Loader
  },
  props: {
    Unit: Object,
    Students: Array,
    ScoreTemplates: Array,
    Subject: Object
  },
  data() {
    return {
      unitTitle: "",
      unitDescription: "",
      unitStudents: [],
      scoreTemplate: null,
      loading: false,
      studentUnitScores: [],
      page: 1,
      changingTemplate: false,
      selectedScoreTemplate: null
    };
  },
  watch: {
    Unit: function() {
      if (this.Unit != null) {
        this.studentUnitScores = [];
        this.unitTitle = this.Unit.Title;
        this.unitDescription = this.Unit.Description;
        this.changingTemplate = false;
        this.scoreTemplate = this.ScoreTemplates.find(
          t => t.Score_Template_Id == this.Unit.Score_Template_Id
        );
        this.selectedScoreTemplate = this.ScoreTemplates.find(
          t => t.Score_Template_Id == this.Unit.Score_Template_Id
        );
        $("#changeTemplate").tooltip({
          title: function() {
            return this.Unit.Num_Scores > 0
              ? "You cannot change the template because there are " +
                  this.Unit.Num_Scores +
                  " scores taken in this unit using this template."
              : "Because there are no scores in this unit using this template, you can change the template you are using.";
          }
        });
      }
    }
  },
  mounted() {
    var view = this;
    $("#manageUnitModal").on("shown.bs.modal", function() {
      $("#name").focus();
    });
    $("#manageUnitModal").on("hide.bs.modal", function() {
      view.getUnitStudents().forEach(student => {
        $(
          "#studentDetails" + student.Student_Id + "unit" + view.Unit.Unit_Id
        ).collapse("hide");
        $(
          "#studentToggleIcon" + student.Student_Id + "unit" + view.Unit.Unit_Id
        ).text("add");
      });
    });
  },
  methods: {
    getStudentUnitScores(studentId) {
      var scores = this.studentUnitScores.find(
        sus => sus.StudentId == studentId
      );
      return scores ? scores.Scores : [];
    },
    getUnitStudents() {
      var students = [];
      if (this.Students != null) {
        students = this.Students.filter(s =>
          s.Units.some(u => u.Unit_Id == this.Unit.Unit_Id)
        );
      }
      return students;
    },
    async updateUnit() {
      var view = this;
      view.changingTemplate = false;
      view.loading = true;
      var unitToUpdate = view.Unit;
      unitToUpdate.Title = view.unitTitle;
      unitToUpdate.Description = view.unitDescription;
      unitToUpdate.Subject_Id = view.Subject.Subject_Id;
      unitToUpdate.Score_Template_Id =
        view.selectedScoreTemplate.Score_Template_Id;
      view.scoreTemplate = view.selectedScoreTemplate;

      await this.$updateUnit(unitToUpdate)
        .then(async () => {
          view.loading = false;
          view.$emit("edited-unit", unitToUpdate);
        })
        .catch(e => {
          console.log(e);
          view.loading = false;
        });
    },
    async selectStudent(studentId) {
      if (
        $(
          "#studentToggleIcon" + studentId + "unit" + this.Unit.Unit_Id
        ).text() == "add"
      ) {
        this.loading = true;
        var scores = await this.$getScoresByStudentAndUnit(
          studentId,
          this.Unit.Unit_Id
        );
        var studentUnitScoresIndex = this.studentUnitScores.findIndex(
          sus => sus.StudentId == studentId
        );
        if (studentUnitScoresIndex == -1) {
          this.studentUnitScores.push({ StudentId: studentId, Scores: scores });
        } else {
          this.$set(this.studentUnitScores, studentUnitScoresIndex, {
            StudentId: studentId,
            Scores: scores
          });
        }
        this.loading = false;
      }
      this.$updateToggleIcon(
        "#studentToggleIcon" + studentId + "unit" + this.Unit.Unit_Id
      );
    },
    async archiveStudentUnit(unit, student) {
      this.$store.commit("updateLoading", true);
      await this.$archiveStudentUnitsPairs([
        { student: student, unitIds: [unit.Unit_Id] }
      ]);
      this.$emit("student-unit-archived", student.Student_Id, unit);
      this.$store.commit("updateLoading", false);
      this.$showSnackbar(
        student.Name + " - " + unit.Title + " has been archived.",
        false
      );
    },
    async archiveUnit() {
      $("#manageUnitModal").modal("hide");
      this.$store.commit("updateLoading", true);
      await this.$archiveUnit(this.Unit.Unit_Id);
      this.$store.commit("updateLoading", false);
      this.$showSnackbar(this.Unit.Title + " has been archived.", false);
      this.$emit("unit-archived", this.Unit);
    },
    changeTemplate() {
      this.changingTemplate = true;
      var CONTROL_INTERVAL = setInterval(function() {
        if ($("#editScoreTemplate").length > 0) {
          $("#editScoreTemplate").selectpicker(
            "val",
            this.selectedScoreTemplate
          );
          $("#editScoreTemplate").selectpicker("refresh");
          clearInterval(CONTROL_INTERVAL);
        }
      }, 100);
    },
    cancelEditTemplate() {
      this.changingTemplate = false;
      this.selectedScoreTemplate = this.ScoreTemplates.find(
        t => t.Score_Template_Id == this.Unit.Score_Template_Id
      );
    }
  }
};
</script>
